import React, { Component } from "react";
import { app } from "../../index";
import { bindActionCreators } from "redux";
import { closemodal } from "../../actions/modal-handler";
import { connect } from "react-redux";
import {
  Icon,
  Modal,
  Header,
  Form,
  Button,
  Image,
  Message
} from "semantic-ui-react";
// import app from "../../services/express-client";

class PassModal extends Component {
  constructor() {
    super();
    this.state = {
      password: "",
      newpassword: "",
      check: false,
      passwordreset: false
    };
  }
  handlepasspatch() {
    console.log(this.props.myinfo.userid);
    app.service("login").patch(this.props.myinfo.userid, {
        password: this.state.password
      })
      .then(response => {
        this.setState({ passwordreset: true });
        console.log(response);
      });
  }
  genmsg() {
    if (this.state.check && this.state.newpassword !== this.state.password) {
      return (
        <Message
          error
          header="Invalid Credentials"
          content="passwords do not match"
        />
      );
    } else if (this.state.passwordreset) {
      return (
        <Message info header="Success" content="Password has been updated." />
      );
    }
  }
  render() {
    return (
      <div className="PassModal">
        <Modal
          open={this.props.showModal}
          onClose={() => this.props.closemodal()}
          size="small"
        >
          <Header as="h2">
            <Image
              src={require("./edf_logo.bmp")}
              size="small"
              id="loginheader"
            />
            Reset Password
          </Header>
          <Modal.Content>
            <Form>
              <Form.Field>
                <label>New Password</label>
                <input
                  placeholder="Password"
                  type="password"
                  value={this.state.password}
                  onChange={e => this.setState({ password: e.target.value })}
                />
              </Form.Field>

              <Form.Field>
                <label>New Password Again</label>
                <input
                  placeholder="Password"
                  type="password"
                  value={this.state.newpassword}
                  onBlur={() => {
                    this.setState({ check: true });
                  }}
                  onChange={e => this.setState({ newpassword: e.target.value })}
                  warning={
                    this.state.check &&
                    this.state.newpassword !== this.state.password
                  }
                />
              </Form.Field>
            </Form>
            {this.genmsg()}
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="green"
              type="submit"
              disabled={
                this.state.password !== this.state.newpassword ||
                this.state.passwordreset
              }
              onClick={() => this.handlepasspatch()}
              inverted
            >
              <Icon name="checkmark" /> Update Password
            </Button>
          </Modal.Actions>
        </Modal>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    myinfo: state.myinfo.employeeinfo,
    showModal: state.modal === "resetpass"
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      closemodal: closemodal
    },
    dispatch
  );
}
export default connect(
  mapStateToProps,
  matchDispatchToProps
)(PassModal);



// WEBPACK FOOTER //
// ./src/components/shared-components/ResetPassModal.js